import outtaHover from "../Images/OuttaWax/hover.jpg";
import pettesHover from "../Images/PettesHounds/hover.jpg";
import yhaHover from "../Images/YHA/hover.jpg";
import neuroHover from "../Images/Neurotype/hover.jpg";
import soonaHover from "../Images/Soona/hover.jpg";
import parraHover from "../Images/Parralily/hover.jpg";
import northTableHover from "../Images/NorthTable/hover.png";

const portfolioItems = [
  {
    id: "northtable",
    link: "/northtable",
    title: "The North Table",
    workType: "minneapolis food truck | web design",
    image: northTableHover,
    marquee: ["The North Table", "|", "Web Design"],
  },
  {
    id: "outta",
    link: "/outtawax",
    title: "Outta Wax",
    workType: "vinyl pressing services | web design",
    image: outtaHover,
    marquee: ["Outta Wax", "|", "Web Design"],
  },
  {
    id: "parralily",
    link: "/parralily",
    title: "ParraLily",
    workType: "minneapolis food truck | web design",
    image: parraHover,
    marquee: ["ParraLily", "|", "Web Design + Dev"],
  },
  {
    id: "pettes",
    link: "/petteshounds",
    title: "Pette's Hounds",
    workType: "dog walking & pet care services | web redesign",
    image: pettesHover,
    marquee: ["Pette's Hounds", "|", "Web Redesign"],
  },
  {
    id: "neuro",
    link: "/neurotype",
    title: "Neurotype",
    workType: "medical startup | ux ui design",
    image: neuroHover,
    marquee: ["Neurotype", "|", "UX UI Design"],
  },
  {
    id: "soona",
    link: "/soona",
    title: "Soona",
    workType: "24 hr content studio | ux ui design",
    image: soonaHover,
    marquee: ["Soona", "|", "UX UI Design"],
  },
  {
    id: "yha",
    link: "/yha",
    title: "Health & Wellness App",
    workType: "Self-defined project | web + ux ui design",
    image: yhaHover,
    marquee: ["Health & Wellness App", "|", "Web + UX UI Design"],
  },
];

export default portfolioItems;
